import { render, staticRenderFns } from "./BaseTransactionDetailsWithdraw.vue?vue&type=template&id=5dabf060&scoped=true&"
import script from "./BaseTransactionDetailsWithdraw.vue?vue&type=script&lang=js&"
export * from "./BaseTransactionDetailsWithdraw.vue?vue&type=script&lang=js&"
import style0 from "./BaseTransactionDetailsWithdraw.vue?vue&type=style&index=0&id=5dabf060&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dabf060",
  null
  
)

export default component.exports